import {
  useCallback,
} from 'react';
import type {
  ComponentType,
  ReactElement,
} from 'react';
import type {
  RouteComponentProps,
} from 'react-router-dom';

import type {
  TabId,
} from '../Tabs';

import type {
  NestedRouteComponent,
  NestedRouteLayoutProps,
  NestedRouteLayoutPropsWithCurrentTab,
} from './types';

export type TabRouteProps<Payload> = {
  currentTab: TabId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routeProps: RouteComponentProps<any>;
  payload: Payload;
  Layout: ComponentType<NestedRouteLayoutPropsWithCurrentTab>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TabComponent: NestedRouteComponent<Payload, any>;
};

export function TabRoute<Payload>({
  currentTab,
  routeProps,
  payload,
  Layout,
  TabComponent,
}: TabRouteProps<Payload>): ReactElement {
  const LayoutWrapper = useCallback(
    (layoutWrapperProps: NestedRouteLayoutProps): ReactElement => (
      <Layout
        {...layoutWrapperProps}
        currentTab={currentTab}
      />
    ),
    [Layout, currentTab],
  );

  return (
    <TabComponent
      {...routeProps}
      payload={payload}
      Layout={LayoutWrapper}
    />
  );
}
